const currency = {
        all: [
            { value: 'BRL', label: 'Real' },
            { value: 'USD', label: 'Dolar' },
            { value: 'AOA', label: 'Angola' },
            { value: 'EUR', label: 'Euro' },
        ],
        foreign: [
            { value: 'USD', label: 'Dolar' },
            { value: 'EUR', label: 'Euro' },
        ],
    };

export default currency;
